import { useTranslation } from "react-i18next";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { NativeSelect } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import React from "react";
import { useStylesBoa } from "./style";
import { BootstrapInput } from "./bootstrapInput";
import { amountFormat } from "../../../utils/WalletUtils";

const FeeOption = (props) => {
  const { t } = useTranslation();
  const classes = useStylesBoa();
  const { fee, feeOptionChangeHandler, error, feeOption } = props;

  return (
    <div className="TableBg cardBg mt-30">
      <div className="ContHeader pendingTable">
        <h3>{t("Fee")}</h3>
      </div>
      <div className="ReceiveInput">
        <div className="addressInput">
          <div className="desktop_view">
            <FormControl>
              <InputLabel id="demo-customized-select-label">
                {t("Option")}
              </InputLabel>
              <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                value={feeOption}
                onChange={feeOptionChangeHandler}
                input={<BootstrapInput />}
                fullWidth
                MenuProps={{
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value="0">{t("High")}</MenuItem>
                <MenuItem value="1">{t("Medium")}</MenuItem>
                <MenuItem value="2">{t("Low")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className="mobile_view">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="native-select">{t("Option")}</InputLabel>
              <NativeSelect
                native="true"
                value={feeOption}
                onChange={feeOptionChangeHandler}
                input={<BootstrapInput />}
                variant="outlined"
                fullWidth
              >
                <option value="0">{t("High")}</option>
                <option value="1">{t("Medium")}</option>
                <option value="2">{t("Low")}</option>
              </NativeSelect>
            </FormControl>
          </div>
        </div>
        <div className="AmountInput">
          <TextField
            label={t("Fee")}
            InputLabelProps={{
              shrink: true,
            }}
            type="text"
            value={fee && amountFormat(fee)}
          />
          <span className="boa">BOA</span>
          <span className="validText">{error}</span>
        </div>
      </div>
      {props.children && (
        <>
          <div className="space" />
          <hr />
          {props.children}
        </>
      )}
    </div>
  );
};
export default React.memo(FeeOption);
